// @ts-nocheck
import { convertTime, getTimeDiff, isTimeTBD } from "./calcUtils";

export function formatValue(value) {
  try {
    if (value == null || isNaN(value)) throw new Error("Invalid input");

    let num = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(num)) throw new Error("Invalid number");

    num = Math.round(num * 10) / 10;

    return Number.isInteger(num) ? num.toString() : num.toFixed(1);
  } catch {
    return "";
  }
}

export function getRateThoughHoursIdx(idx) {
  switch (idx) {
    case 0:
      return 1;
    case 1:
      return 0.5;
    case 2:
      return 1.5;
    case 3:
      return 2;
    case 4:
      return 1.5;
    case 5:
      return 1;
  }
}

export function getDescriptionThoughHoursIdx(idx, isHalfDay) {
  switch (idx) {
    case 0:
      if (isHalfDay) {
        return "Half Day Rate -";
      } else {
        return null;
      }
    case 1:
      return "After Midnight Rate -";
    case 2:
      return "Over Time Rate -";
    case 3:
      return "Double Time Rate -";
    case 4:
      return "Meal Penalty Rate -";
    case 5:
      return "Travel Charges -";
  }
}
export function getDescriptionThoughHoursIdxInvoice(idx, isHalfDay) {
  switch (idx) {
    case 0:
      if (isHalfDay) {
        return "HD";
      } else {
        return null;
      }
    case 1:
      return "Midnight OT";
    case 2:
      return "OT";
    case 3:
      return "DT";
    case 4:
      return "MP";
    case 5:
      return "Travel Charges";
  }
}

export function getTimeDiffOfPositionsOnlyNumberOfHours({
  pos,
  eventInfo,
  terms,
}) {
  if (isTimeTBD(pos?.timeIn) || isTimeTBD(pos?.timeOut))
    return pos?.numberOfHours;
  else {
    const { timeDiff } = getTimeDiff(
      convertTime({ dateStr: pos?.timeIn, timezone: eventInfo?.eventTimezone }),
      convertTime({
        dateStr: pos?.timeOut,
        timezone: eventInfo?.eventTimezone,
      }),
      {
        halfDay: terms?.halfDay,
        fullDay: terms?.fullDay,
        overTime: terms?.overTime,
      },
    );
    return timeDiff;
  }
}